export default __webpack_public_path__ + "static/media/chevron-right.311e8f2e.svg";